export enum GridMode {
  LOADING = "loading",
  SERVER = "server",
  CLIENT = "client",
}
